import { useEffect } from 'react';
import httpClient from '../../../apis/http';

const headerName = 'Authorization';

function useAuthorizationHeader(accessToken) {
  useEffect(() => {
    if (!accessToken) {
      httpClient.headers.remove(headerName);
    } else {
      httpClient.headers.add(headerName, `Bearer ${accessToken}`);
    }
  }, [accessToken]);
}

export default useAuthorizationHeader;
